export default "__VITE_ASSET__923ec652__"